import { Commands, Events, eventsManager, SceneConstants } from "@rhinov/savane-js";
import { ResultsWidget } from "../ResultsWidget";
import { ResultsController } from "../Tools/ResultsController";

import { PlanManager } from '@rhinov/cocos-plan'
import { _ASSET_TYPE, getFrontUrl } from "@rhinov/asset-manager-service";


export class ResultsOverlayWidget {
    
    controller: ResultsController;
    static allArrangementObjects: any | null = null;//(typeof PlanManager === 'undefined') ? [] : PlanManager.getInstance().world.currentScene.arrangementObjects;
    static allCoatingObjects: any | null = null;//(typeof PlanManager === 'undefined') ? [] : PlanManager.getInstance().world.currentScene.coatings;
    static allGroupObjects: any | null = null;//(typeof PlanManager === 'undefined') ? [] : PlanManager.getInstance().world.currentScene.arrangementGroups;
    static projectLoaded: any | null = null;
    static projectUpdated: any | null = null;
    static reloadListener: any | null = null;
    static componentAddedListener: any | null = null;
    static componentRemovedListener: any | null = null;
    static commandListener: any;

    openUrl: (url: string) => void;
    openDetailsFunc: (url: string) => void;
    currentResource: any;

    constructor(openUrl: (url: string) => void, openDetailsFunc: (url: string) => void, currentResource: any) {
        this.openUrl = openUrl;
        this.openDetailsFunc = openDetailsFunc;
        this.currentResource = currentResource;
        this.controller = new ResultsController();

        // Initialize listeners
        if (!ResultsOverlayWidget.projectLoaded) {
            ResultsOverlayWidget.projectLoaded = eventsManager.instance.addListener(Events.PROJECT_DID_LOAD, ResultsOverlayWidget.refreshArrangementObjectList);
            ResultsOverlayWidget.projectUpdated = eventsManager.instance.addListener(Events.UPDATE_RHINOV_FORMAT, ResultsOverlayWidget.refreshArrangementObjectList);
            ResultsOverlayWidget.reloadListener = eventsManager.instance.addListener(Events.PROJECT_RELOAD, ResultsOverlayWidget.refreshArrangementObjectList);
            ResultsOverlayWidget.componentAddedListener = eventsManager.instance.addListener(Events.COMPONENT_ADDED, ResultsOverlayWidget.refreshArrangementObjectList);
            ResultsOverlayWidget.componentRemovedListener = eventsManager.instance.addListener(Events.COMPONENT_REMOVED, ResultsOverlayWidget.refreshArrangementObjectList);
        }

        ResultsOverlayWidget.commandListener = eventsManager.instance.addListener(Events.COMMAND_EXECUTED, function (event: any) {
            const instance = PlanManager.getInstance();
            if (!instance.world.currentScene) return;
            // Depending on the command name (see Command.js from CocosPlanModule/src/cocos/scripts/command)
            switch (event.userData.name) {
                case Commands.CommandEnum.AddEntityCommand:
                case Commands.CommandEnum.DeleteEntityCommand:
                    if (event.userData.datas.type === SceneConstants.EntityType.ArrangementObject) {
                        ResultsOverlayWidget.allArrangementObjects = instance.world.currentScene.arrangementObjects;
                    }
                    if (event.userData.datas.type === SceneConstants.EntityType.ArrangementGroup) {
                        ResultsOverlayWidget.allArrangementObjects = instance.world.currentScene.arrangementObjects;
                        ResultsOverlayWidget.allGroupObjects = instance.world.currentScene.arrangementGroups;
                    }
                    break;

                case Commands.CommandEnum.DeleteGroupCommand:
                    ResultsOverlayWidget.allGroupObjects = instance.world.currentScene.arrangementGroups;
                    break;

                case Commands.CommandEnum.ChangeCoatingCommand:
                case Commands.CommandEnum.DeleteComponentCommand:
                    ResultsOverlayWidget.allCoatingObjects = instance.world.currentScene.coatings;
                    break;
            }
        });
    }

    static refreshArrangementObjectList() {
        if (typeof PlanManager === 'undefined') {
            return;
        }

        const instance = PlanManager.getInstance();
        if (!instance.world.currentScene) return;
        ResultsOverlayWidget.allArrangementObjects = instance.world.currentScene.arrangementObjects;
        ResultsOverlayWidget.allCoatingObjects = instance.world.currentScene.coatings;
        ResultsOverlayWidget.allGroupObjects = instance.world.currentScene.arrangementGroups;
    };

    static isUsedInProject(resource: any) {
        var i;
        const instance = PlanManager.getInstance();

        if (resource.kind === 'Arrangement') {
            if (ResultsOverlayWidget.allArrangementObjects === null) {
                if (instance.world.currentScene) {
                    ResultsOverlayWidget.allArrangementObjects = instance.world.currentScene.arrangementObjects;
                }
            }
            if (ResultsOverlayWidget.allArrangementObjects) {
                for (i = 0; i < ResultsOverlayWidget.allArrangementObjects.length; i++) {
                    if (resource._id === ResultsOverlayWidget.allArrangementObjects[i]._objectId) {
                        return (true);
                    }
                }
            }
        }

        if (resource.kind === 'Coating') {
            if (ResultsOverlayWidget.allCoatingObjects === null) {
                if (instance.world.currentScene) {
                    ResultsOverlayWidget.allCoatingObjects = instance.world.currentScene.coatings;
                }
            }
            if (ResultsOverlayWidget.allCoatingObjects) {
                for (i = 0; i < ResultsOverlayWidget.allCoatingObjects.length; i++) {
                    if (resource._id === ResultsOverlayWidget.allCoatingObjects[i]._coatingId) {
                        return (true);
                    }
                }
            }
        }

        if (!resource.kind) {
            if (ResultsOverlayWidget.allGroupObjects === null) {
                if (instance.world.currentScene) {
                    ResultsOverlayWidget.allGroupObjects = instance.world.currentScene.arrangementGroups;
                }
            }
            if (ResultsOverlayWidget.allGroupObjects) {
                for (i = 0; i < ResultsOverlayWidget.allGroupObjects.length; i++) {
                    if (resource._id === ResultsOverlayWidget.allGroupObjects[i]._objectId) {
                        return (true);
                    }
                }
            }
        }

        return (false);
    };

    static generatePriceString(resource: any) {
        var priceString = '';
        if (resource.price !== undefined && resource.price.value !== undefined) {
            priceString = '' + resource.price.value;
            if (resource.price.currency !== undefined) {
                if (resource.price.currency === 'EUR') {
                    priceString += '€';
                }
                if (resource.price.currency === 'GBP') {
                    priceString += '£';
                }
                if (resource.price.currency === 'USD') {
                    priceString += '$';
                }
            }
        }
        return priceString;
    };

    static getAvailabilityTitle(resource: any) {
        if (resource.manufacturer._id !== '579b5fc0d7ee59f805e3c065') {
            return ("");
        }

        if (resource.pipeline.state === 'terminated') {
            return ("Rupture définitive");
        }

        if (resource.pipeline.state === 'archived') {
            return ("Rupture temporaire");
        }

        return ("Disponible");
    };

    static getAvailability(resource: any) {
        if (resource.manufacturer._id !== '579b5fc0d7ee59f805e3c065') {
            return ("rgb(211, 211, 211)");
        }

        if (resource.pipeline.state === 'terminated') {
            return ("rgb(255, 0, 0)");
        }

        if (resource.pipeline.state === 'archived') {
            return ("rgb(255, 188, 0)");
        }

        if (resource.marketStatus === 'noos') {
            return ("rgb(0, 128, 0)");
        }

        return ("rgb(211, 211, 211)");
    };

    static getDiscount(resource: any) {
        if (resource.saleState === 'on_sale') {
            return ("rgb(0, 128, 0);font-weight: 800");
        }
        return ("rgb(128, 128, 128)");
    };

    static openUrl(uri: string) {
        if (ResultsWidget.openDetailsFunc) {
            ResultsWidget.openDetailsFunc(uri);
        }
        else {
            window.open(uri);
        }
    };

    static openAssetDetail(resource: any) {
        var uri: string | null = null;
        const decorService = ResultsWidget.getDecorationService();
        if (!decorService) return;

        switch (decorService.group) {
            case _ASSET_TYPE.ARRANGEMENTS:
            case _ASSET_TYPE.PRODUCTS:
                uri = getFrontUrl() + 'arrangements/' + resource._id;
                break;

            case _ASSET_TYPE.COATINGS:
                uri = getFrontUrl() + 'coatings/' + resource._id;
                break;

            case _ASSET_TYPE.TEMPLATES:
                uri = getFrontUrl() + 'assets-groups/' + resource._id;
                break;

            case _ASSET_TYPE.JOINERIES:
                uri = getFrontUrl() + 'joineries/' + resource._id;
                break;

            case _ASSET_TYPE.TECHNICAL_ELEMENTS:
                uri = getFrontUrl() + 'technical-elements/' + resource._id; //@aurelien check typo
                break;

            case _ASSET_TYPE.TAGS:
                break;

            case 'allAssets':
            case 'nextobjects':
            case 'magicsearch':
                switch (resource.kind) {
                    case 'Arrangement':
                        uri = getFrontUrl() + 'arrangements/' + resource._id;
                        break;

                    case 'Joinery':
                        uri = getFrontUrl() + 'joineries/' + resource._id;
                        break;

                    case 'TechnicalElement':
                        uri = getFrontUrl() + 'technical-elements/' + resource._id
                        break;

                    case 'Template':
                        uri = getFrontUrl() + 'asset-groups/' + resource._id;
                        break;

                    case 'Coating':
                        uri = getFrontUrl() + 'coatings/' + resource._id;
                        break;
                }
                break;

            default:
        }
        if (uri) {
            this.openUrl(uri);
        }
    };

    static findAssetInScene(resource: any) {
        if (typeof PlanManager === 'undefined') return;
        const instance = PlanManager.getInstance();
        if (!instance.world.currentScene) return;
        var arrangements = instance.world.currentScene.arrangementObjects;
        var selection: any[] = [];

        for (var i = 0; i < arrangements.length; i++) {
            if (arrangements[i].objectId === resource._id) {
                const arrangedItem = arrangements[i];
                if (!arrangedItem.parent) continue;
                if (!arrangedItem.parent.isArrangementObjectEntity() && !arrangedItem.parent.isArrangementGroupEntity()) {
                    selection.push(arrangedItem);
                }
                else {
                    var parent = arrangedItem.parent;
                    while (parent && parent.parent && (parent.parent.isArrangementObjectEntity() || parent.parent.isArrangementGroupEntity())) {
                        parent = parent.parent;
                    }

                    if (parent) {
                        selection.push(parent);
                    }
                }
            }
        }

        instance.updateItemsSelected(selection, false, false);
    };

    static mouseDownAsset(_asset: any) {
        //Event on mouse down
        ResultsWidget.draggedRes = null;
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        eventsManager.instance.dispatch(Events.HIDE_TOOLTIP_EVENT);
    };

    static sendReplaceArrangement(resource: any) {
        if (resource.kind === 'Arrangement' || resource.kind === undefined) {
            eventsManager.instance.dispatch(Events.REPLACE_SELECTED_ARRANGEMENT, resource);
        }
    };

    addOrRemoveFromPinboards(event: MouseEvent) {
        event.stopPropagation();
        ResultsWidget.cancelDrop(event);
        eventsManager.instance.dispatch(Events.ADD_OR_REMOVE_FROM_PINBOARD, {
            item: this.currentResource,
        })
    };

    addOrRemoveFromAssetsGroupsList(event: MouseEvent) {
        event.stopPropagation();
        ResultsWidget.cancelDrop(event);
        eventsManager.instance.dispatch(Events.ADD_OR_REMOVE_FROM_ASSETS_GROUPS_LIST, {
            item: this.currentResource,
        })
    };

    html() {
        return `
        <!-- Empty ressource container displayed on top of background image of the asset -->
        <div class="Empty-Res-Container" id="empty-${this.currentResource._id}" style="width:100%;height:100%;display:none;" data-no-drag>
            ${this.getUsageIndicatorHtml()}

            ${this.getNewOnSalesProductIndicatorHtml()}

            ${this.getPriceIndicatorHtml()}

            ${this.getFloorGeneratorBadgeHtml()}

            ${this.getAssetProblemIndicatorHtml()}

            ${this.getPinboardToggleHtml()}

            ${this.getAssetsGroupsListToggleHtml()}

            ${this.getMarketLinkHtml()}
        </div>
        `;
    }

    getUsageIndicatorHtml() {
        return `
        <!-- P1 priority displayed top left if manufacturer priority == p1 and ressource available, with green background-->
            <div id="checkmark-${this.currentResource._id}" style="position:absolute;top:${this.currentResource.isHpFloorGenerator ? '10px' : '-2px'};${ResultsOverlayWidget.isUsedInProject(this.currentResource) ? '' : 'display:none'};left:0;height:11px;cursor:pointer;font-size:16px;color:rgb(0, 192, 0);" title="Utilisé">
                <i class="fa-solid fa-check"></i>
            </div>
        `;
    }

    getNewOnSalesProductIndicatorHtml() {
        if (this.currentResource.isNewProduct) {
            return `
            <!-- New product -->
                <div style="position:absolute;top:0;left:32px;height:12px;cursor:pointer;font-size:16px;color:rgb(0, 102, 255);" title="Nouveauté">
                    <i class="fa-solid fa-star"></i>
                </div>
            `;
        }

        return('');
    }

    getPriceIndicatorHtml() {
        return `
        <!-- asset price displayed bottom left -->
        <div style="position:absolute;bottom:0;left:0;height:12px;cursor:pointer;font-size:12px;background-color:rgb(255, 255, 255);color:${ResultsOverlayWidget.getDiscount(this.currentResource)}" title="prix">
            ${ResultsOverlayWidget.generatePriceString(this.currentResource)}
        </div>
        `;
    }

    getFloorGeneratorBadgeHtml() {
        return `
        ${this.currentResource.isHpFloorGenerator ? `
            <div style="position:absolute;top:0;left:0;height:13px;cursor:pointer;font-size:12px;background-color:rgb(255, 255, 255);" title="FG">
              FG
            </div>
        `: ''}`;
    }

    getAssetProblemIndicatorHtml() {
        setTimeout(() => {
            const currentResource = this.currentResource;
            const elements = document.querySelectorAll('.res-overlay-'+this.currentResource._id);
            if(elements.length > 1){
                this.controller.removeEventListeners("mousedown", "res-overlay-"+this.currentResource._id, true);
                this.controller.removeEventListeners("mouseup", "res-overlay-"+this.currentResource._id, true);
            }
            this.controller.addEventListeners("mousedown", (event) => {
                if (event.ctrlKey) {
                    ResultsOverlayWidget.openAssetDetail(currentResource);
                } else if (event.altKey) {
                    ResultsOverlayWidget.findAssetInScene(currentResource);
                } else {
                    ResultsOverlayWidget.mouseDownAsset(currentResource);
                }
            }, 'res-overlay-' + this.currentResource._id, undefined, true);

            this.controller.addEventListeners("mouseup", (event) => {
                if (!event.ctrlKey && !event.altKey) {
                    ResultsOverlayWidget.sendReplaceArrangement(currentResource);
                }
            }, 'res-overlay-' + this.currentResource._id, undefined, true);
        });
        return `
        <div style="width:100%;height:100%;position:relative">
          ${this.currentResource.hasIssues && this.currentResource.manufacturer !== undefined ? `
            <div style="font-size:48px;color:rgb(255, 0, 0);display:flex;justify-content:center;align-items:center;height:100%" title="PROBLEMES !">
                <i class="fa-solid fa-xmark"></i>
            </div>
          ` : ''}
          <div class="res-overlay-${this.currentResource._id}" style="width:100%;height:100%;position:absolute;top:0;left:0" data-no-drag>
          </div>    
        </div>
        `;
    }

    getPinboardToggleHtml() {
        setTimeout(() => {
            const elements = document.querySelectorAll(`.Pinboard-${this.currentResource._id}`);

            if(elements.length > 1){
                this.controller.removeEventListeners("mousedown", `Pinboard-${this.currentResource._id}`);
            }

            this.controller.addEventListeners("mousedown", (event) => {
                this.addOrRemoveFromPinboards(event);
            }, `Pinboard-${this.currentResource._id}`, undefined, true);
        });
        const isPinnedClass = this.currentResource.pinboard ? 'pinned' : '';
        return `
        ${this.currentResource.manufacturer !== undefined ? `
            <div class="Pinboard-${this.currentResource._id}" style="position:absolute;top:0;right:0;height:13px;cursor:pointer;font-size:14px;" title="Pinboard">
              <i class="fas fa-heart pinboard ${isPinnedClass} isPinned-Icon-${this.currentResource._id}"></i>
            </div>
        ` : ''}`;
    }

    getAssetsGroupsListToggleHtml() {
        setTimeout(() => {
            const elements = document.querySelectorAll( `.AssetsGroupsList-${this.currentResource._id}`);

            if(elements.length > 1){
                this.controller.removeEventListeners("mousedown",  `AssetsGroupsList-${this.currentResource._id}`);
            }
            this.controller.addEventListeners("mousedown", (event) => {
                this.addOrRemoveFromAssetsGroupsList(event);
            }, `AssetsGroupsList-${this.currentResource._id}`, undefined, true);
        });
        const decorService = ResultsWidget.getDecorationService();
        return `
        ${this.currentResource.rhinovFormat !== undefined && decorService && decorService.isUserAllowedToManageAssetsGroupsList ? `
            <div class="AssetsGroupsList-${this.currentResource._id}" style="position:absolute;top:0;right:0;height:13px;cursor:pointer;font-size:14px;" title="AssetsGroupsList">
                <i class="fas fa-cubes"></i>
            </div>
        ` : ''}`;
    }

    getMarketLinkHtml() {
        setTimeout(() => {
            const elements = document.querySelectorAll(`.Market-link-${this.currentResource._id}`);

            if(elements.length > 1){
                this.controller.removeEventListeners('mousedown', `Market-link-${this.currentResource._id}`);
            }
            this.controller.addEventListeners("mousedown", (event) => {
                this.openUrl(this.currentResource.marketLink);
                event.stopPropagation();
            }, `Market-link-${this.currentResource._id}`, undefined, true);
        });
        return `
        <!-- market link displayed bottom right -->
        ${this.currentResource.marketLink && this.currentResource.manufacturer !== undefined ? `
            <div class="Market-link-${this.currentResource._id}" style="position:absolute;bottom:0;right:0;height:12px;cursor:pointer;font-size:12px;background-color:rgb(255, 255, 255);
            color:${ResultsOverlayWidget.getAvailability(this.currentResource)}"
            title="${ResultsOverlayWidget.getAvailabilityTitle(this.currentResource)}">
                <i class="fa-solid fa-cart-shopping"></i>
            </div>
        ` : ''}`;
    }

    destroy(): void {
        if (ResultsOverlayWidget.projectLoaded) eventsManager.instance.removeListener(ResultsOverlayWidget.projectLoaded);
        if (ResultsOverlayWidget.projectUpdated) eventsManager.instance.removeListener(ResultsOverlayWidget.projectUpdated);
        if (ResultsOverlayWidget.reloadListener) eventsManager.instance.removeListener(ResultsOverlayWidget.reloadListener);
        if (ResultsOverlayWidget.componentAddedListener) eventsManager.instance.removeListener(ResultsOverlayWidget.componentAddedListener);
        if (ResultsOverlayWidget.componentRemovedListener) eventsManager.instance.removeListener(ResultsOverlayWidget.componentRemovedListener);
        if (ResultsOverlayWidget.commandListener) eventsManager.instance.removeListener(ResultsOverlayWidget.commandListener);
    }
}